"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const NumberFormatter_1 = __importDefault(require("@react/web/Common/NumberFormatter/NumberFormatter"));
class ContractLength {
    constructor(active, value, price) {
        this.active = active;
        this.value = value;
        this.price = price;
    }
    getLabel() {
        return NumberFormatter_1.default.formatMonths(this.value);
    }
    getKey() {
        return `contract-length-${this.value}`;
    }
}
exports.default = ContractLength;
